import firebase from 'firebase'
import _ from 'underscore'
import moment from 'moment'

export default {
  createCardMetrics(card) {
    return {
      cardId: card.id,
      metrics: {
        identifier: card.identifier,
        contentId: card.contentId,

        startTime: new Date(),
        endTime: null,
        flipTime: [],

        stage: null,
        result: null,

        questionTimeSeconds: null,
        answerTimeSeconds: null,
        totalTimeSeconds: null,
      },
      timeEndSet() {
        this.metrics.endTime = new Date()
      },
      recordFlip() {
        this.metrics.flipTime.push(new Date())
      },
      recordCardResult(stage, result) {
        this.metrics.endTime = new Date()
        this.metrics.stage = stage
        this.metrics.result = result

        this.calculateTimeSpent()
      },
      calculateTimeSpent() {
        //add time spent
        let start = moment(this.metrics.startTime)
        let flip = moment(this.metrics.flipTime[0])
        let end = moment(this.metrics.endTime)
        this.metrics.questionTimeSeconds = flip.diff(start, 'seconds')
        this.metrics.answerTimeSeconds = end.diff(flip, 'seconds')
        this.metrics.totalTimeSeconds = end.diff(start, 'seconds')
      },
      DBrecordCardState(deckId) {
        firebase.firestore().collection('learningRecord')
        .doc(firebase.auth().currentUser.uid)
        .collection('cardRecord')
        .doc(this.cardId).set({
            cardId: this.cardId,
            lastPractice: new Date(),
            uid: firebase.auth().currentUser.uid,
            deckId,
            history: firebase.firestore.FieldValue.arrayUnion(this.metrics)
        }, { merge: true });
      },
    }


  },
  createDeckMetrics(deckId) {
    return {
      uid: firebase.auth().currentUser.uid,
      deckId: deckId,
      metrics: {
        timeAssess: null,
        timeLearn: null,
        timeReview: null,
        timeCompete: null,
        assessTrue: 0,
        assessFalse: 0,
        assessScore: null,
        totalTimeSeconds: null,
        totalCards: null,
        initialConfidence: null, //value 1-5
        answerHistory: [],
      },
      restoreDataFromLastSession(metrics) {
        this.metrics = metrics
        if (this.metrics.timeAssess != null) {
          this.metrics.timeAssess = moment(this.metrics.timeAssess.toDate()).toDate()
        }
        if (this.metrics.timeLearn != null) {
          this.metrics.timeLearn = moment(this.metrics.timeLearn.toDate()).toDate()
        }
        if (this.metrics.timeReview != null) {
          this.metrics.timeReview = moment(this.metrics.timeReview.toDate()).toDate()

        }
        //restore dates from timestamps in firestore for answerHistory
        this.metrics.answerHistory.forEach(item => {
          item.endTime = item.endTime.toDate()
          item.startTime = item.startTime.toDate()
          item.flipTime.forEach(flip => {
            flip = flip.toDate()
          })
        })
      },
      timeAssessSet() {
        this.metrics.timeAssess = new Date()
      },
      timeLearnSet() {
        this.metrics.timeLearn = new Date()
      },
      timeLearnClear() {
        this.metrics.timeLearn = null
      },
      timeReviewSet() {
        this.metrics.timeReview = new Date()
      },
      timeReviewClear() {
        this.metrics.timeReview = null
      },
      timeCompeteSet() {
        this.metrics.timeCompete = new Date()
      },
      incrementAssessTrue() {
        this.metrics.assessTrue += 1
      },
      incrementAssessFalse() {
        this.metrics.assessFalse += 1
      },
      decrementAssessTrue() {
        this.metrics.assessTrue -= 1
      },
      decrementAssessFalse() {
        this.metrics.assessFalse -= 1
      },
      recordInitialConfidence(val) {
        this.metrics.initialConfidence = val
      },
      recordAnswerHistory(answer) {
        this.metrics.answerHistory.push(answer)
      },
      DBrecordDeckState(learningState) {
        let record = {}

        record['deckMetrics'] = this.metrics
        record['learningState'] = learningState

        firebase.firestore().collection('learningRecord')
        .doc(this.uid)
        .collection('deckRecord')
        .doc(this.deckId).set({
            lastPractice: new Date(),
            currentSession: record,
            deckId: this.deckId,
            uid: this.uid,
        }, { merge: true });
      },
      DBrecordDeckTermination(learningState) {
        let record = {}
        record['deckMetrics'] = this.metrics
        record['learningState'] = learningState

        firebase.firestore().collection('learningRecord')
        .doc(this.uid)
        .collection('deckRecord')
        .doc(this.deckId).set({
            history: firebase.firestore.FieldValue.arrayUnion(record),
            currentSession: null,
            lastClosedSession: new Date(),
            nextSuggestedSession: this.nextSuggestedSession(),
            deckId: this.deckId,
            uid: firebase.auth().currentUser.uid,
        }, { merge: true });
      },
      nextSuggestedSession() {
        return moment().add(7,'days').toDate()
      },
      calculateCompletionMetrics() {
        this.metrics.assessScore =  this.metrics.assessTrue / (this.metrics.assessTrue + this.metrics.assessFalse)
        this.metrics.totalCards = this.metrics.answerHistory.length

          let extraTimeSeconds = 0
          for (let i = 1; i < this.metrics.answerHistory.length; i++) {
            let a = moment(this.metrics.answerHistory[i-1].endTime)
            let b = moment(this.metrics.answerHistory[i].endTime)
            let diff = b.diff(a, 'seconds')
            if (diff > 180) { //if more than 3 minutes passes, subtract that from the total time spent
              extraTimeSeconds += diff
            }
          }
          let totalTime = moment(this.metrics.timeComplete).diff(moment(this.metrics.timeAssess), 'seconds')

          let finalTime = totalTime - extraTimeSeconds

          this.metrics.totalTimeSeconds = finalTime

      }
    }
  }

}
